import { CheckSkeleton } from "../../SharedModule/utils/checkSkeleton";
import { SLASH, THIS_WEEK } from "../../SharedModule/utils/constants";
import { getNextWeekDay } from "../../SharedModule/utils/dateUtils";
import { quantityFormat } from "../../SharedModule/utils/formatters";

export const SummaryTotals = (props) => {
  // ONLY FOR TIMES PAGE - we avoid this for approval and query results
  // to actual week, we must use actual day minus one.
  // in the past, we should calculate with fridays (5). On future, should not be red.
  let dayNumberToCalculate = 0;
  if (props.pageDate) {
    if (props.showedWeek === THIS_WEEK) {
      dayNumberToCalculate = new Date().getDay() - 1;
    } else if (getNextWeekDay(6, props.pageDate) < new Date()) {
      dayNumberToCalculate = 5;
    }
  }

  let missingHours =
    !props.avoidCheckMissingHours &&
    props.totals !== 0 &&
    props.totals - dayNumberToCalculate * props.scheduledHours < 0;

  return (
    <>
      {props.showTitle && (
        <div className="summary-title">
          Summary totals:{" "}
          {props.isLoading ? (
            <output
              className="spinner-border spinner-border-sm ms-1"
              aria-hidden="true"
            ></output>
          ) : (
            <span className="summary-title-value ms-1 toCapitalize">
              {props.showedWeek}
            </span>
          )}
        </div>
      )}
      <div
        className="card d-flex flex-row flex-wrap invoice-summary-background"
        style={{ marginTop: "12px" }}
      >
        <div className="flex-fill border-end" style={{ padding: "12px 24px" }}>
          <div
            className={`summary-section-title ${
              missingHours ? "text-error" : ""
            }`}
          >
            Total hours
          </div>
          <CheckSkeleton isLoading={props.isLoading} classes="fs-4 pb-1">
            <div
              className={`summary-section-number pb-1 ${
                missingHours ? "text-error" : ""
              }`}
            >
              {quantityFormat(props.totals)}
            </div>
          </CheckSkeleton>
        </div>
        <div className="flex-fill border-end" style={{ padding: "12px 24px" }}>
          <div className="summary-section-title">Billable hours</div>
          <CheckSkeleton isLoading={props.isLoading} classes="fs-4 pb-1">
            <div className="summary-section-number pb-1">
              {props.billable !== 0 ? quantityFormat(props.billable) : SLASH}
            </div>
          </CheckSkeleton>
        </div>
        <div className="flex-fill border-end" style={{ padding: "12px 24px" }}>
          <div className="summary-section-title">Financed hours</div>
          <CheckSkeleton isLoading={props.isLoading} classes="fs-4 pb-1">
            <div className="summary-section-number pb-1">
              {props.financed !== 0 ? quantityFormat(props.financed) : SLASH}
            </div>
          </CheckSkeleton>
        </div>
        <div className="flex-fill border-end" style={{ padding: "12px 24px" }}>
          <div className="summary-section-title">Non-Billable hours</div>
          <CheckSkeleton isLoading={props.isLoading} classes="fs-4 pb-1">
            <div className="summary-section-number pb-1">
              {props.nonBillable !== 0
                ? quantityFormat(props.nonBillable)
                : SLASH}
            </div>
          </CheckSkeleton>
        </div>
        <div className="flex-fill border-end" style={{ padding: "12px 24px" }}>
          <div className="summary-section-title">Internal hours</div>
          <CheckSkeleton isLoading={props.isLoading} classes="fs-4 pb-1">
            <div className="summary-section-number pb-1">
              {props.internal !== 0 ? quantityFormat(props.internal) : SLASH}
            </div>
          </CheckSkeleton>
        </div>
        <div className="flex-fill" style={{ padding: "12px 24px" }}>
          <div className="summary-section-title">Time Off hours</div>
          <CheckSkeleton isLoading={props.isLoading} classes="fs-4 pb-1">
            <div className="summary-section-number pb-1">
              {props.timeOff !== 0 ? quantityFormat(props.timeOff) : SLASH}
            </div>
          </CheckSkeleton>
        </div>
      </div>
    </>
  );
};
